// extracted by mini-css-extract-plugin
export default {"target":"CareElementTarget_target__HcEJv"};